<template>
  <div class="py-8 layout-product-testimonials">
    <div v-if="reviewsSlice.length>0" class="text-2xl title sm:s-48 w-500">
      <h2>Отзывы</h2>
      <div>{{ this.$store.state.langs.REVIEWS_TITLE }}</div>
    </div>
    <div v-else class="text-2xl title sm:s-48 w-500"><div>Оставьте первый отзыв о данном товаре</div></div>
    <span
        @click="popupOpened = true"
        style="display: inline-block; margin-top: 1em; cursor: pointer;"
        class="s-16 w-500 dashed opacity-80"
    >
      <div>{{ this.$store.state.langs.REVIEWS_BUTTON }}</div>
    </span>
<!--    <div style="margin-top: 2em;" class="s-14 w-600 uppercase opacity-60"><div>{{ this.$store.state.langs.REVIEWS_SUBTITLE }}</div></div>-->
    <!--  -->
    <div class="container content-wrapper">
        <layout-testimonial-card
            v-for="(review, key, index) in reviewsSlice"
            :key="key"
            :mark="Number( review.PROPERTY_REVIEWS_RATING_VALUE )"
            :useful="4"
            :unuseful="2"
            :text="review.DETAIL_TEXT"
        >
          <template #name>{{ review.PROPERTY_REVIEWS_NIC_VALUE }}<span v-if="review.PROPERTY_REVIEWS_CITY_VALUE">, г. {{ review.PROPERTY_REVIEWS_CITY_VALUE }}</span></template>
        </layout-testimonial-card>
    </div>
    <!--  -->
    <div class="suffix" v-if="reviews.length>3 && reviewsButton">
        <ui-button @click="reviewsViewsAll">{{ this.$store.state.langs.REVIEWS_READER_ALL }}</ui-button>
    </div>

    <layout-popup small-padding :sended="sended" :subText="false" v-model="popupOpened">
      <div class="s-30 w-500">Оставить отзыв</div>
      <div class="s-16 opacity-80">Опишите впечатления о товаре</div>
      <template slot="form">
        <div class="row-fields">
          <input required placeholder="Как Вас зовут" v-model="name" type="text" class="ui-input" />
          <input required placeholder="Ваш город" type="name" v-model="city" class="ui-input" />
        </div>
        <div class="row-fields">
          <div name="CLIENT_EMAIL">
            <input required placeholder="Email" v-model="email" type="email" class="ui-input" />
          </div>
          <input v-model="phone" class="ui-input" type="tel" name="CLIENT_PHONE" placeholder="Введите телефон" required />
<!--          <phone-mask-input
              v-model="phone"
              name="CLIENT_PHONE"
              autoDetectCountry
              @onValidate="onValidate"
              inputClass="ui-input"
              placeholder=""
              required
          />-->
        </div>
        <div class="rainting">
          <div class="s-16 w-600">Ваша оценка</div>
          <ui-raiting allow-edit v-model="raiting"></ui-raiting>
        </div>
        <textarea
            style="text-align: left"
            placeholder="Введите текст отзыва"
            class="ui-input"
            @onValidate="onValidate"
            required
            v-model="text"
            rows="4"
        ></textarea>
        <ui-button @click="sendTestimonials" style="margin-top: 25px">Оставить отзыв</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш email, вы соглашаетесь с политикой обработки персональных данных
      </div>
    </layout-popup>

  </div>
</template>

<script>
import { Slide, Carousel } from 'vue-carousel'
import PhoneMaskInput from  "vue-phone-mask-input";
export default {
  props: {
    article: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      tabs: ['Комфорт', 'Размер', 'Качество сна'],
      current: 'Комфорт',
      reviews: [],
      reviewsSlice: [],
      reviewsButton: true,
      popupOpened: false,
      raiting: 5,
      sended: false,
      name: "",
      city: "",
      email: "",
      phone: "",
      text: "",
      validPhone: false,
      pageScroll200: false,
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      if(!this.pageScroll200 && pageYOffset > 200){
        this.pageScroll200 = true;
        this.requestTestimonials();
      }
   });
    this.$bus.$on('updateSended', () => {
      this.sended=false;
    });
  },
  methods: {
    reviewsViewsAll(){
      this.reviewsSlice = this.reviews;
      this.reviewsButton = false;
    },
    requestTestimonials(){
      this.$axios({
        url: '/ajax/testimonials.php',
        headers: {'Content-Type': 'application/json'},
        method: 'post',
        data: {
          article: this.article,
          site_id: this.$store.state.siteid,
          template_site: this.$store.state.langs.TEMPLATE_SITE
        }
      }).then(response => {
        if (response.status == 200) {
          this.reviews = response.data;
          this.reviewsSlice = this.products = response.data.slice(0, 3);
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
    },
    onValidate(ev){
      this.validPhone = !!ev.isValidByLibPhoneNumberJs;
    },
    sendTestimonials(){

      /*if( this.phone=="" || !this.validPhone ){
        this.showError("CLIENT_PHONE");
        return false;
      } else {
        this.hideError("CLIENT_PHONE");
      }*/
      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      if( this.email == "" || !EMAIL_REGEXP.test(this.email) ){
        this.showError("CLIENT_EMAIL");
        return false;
      } else {
        this.hideError("CLIENT_EMAIL");
      }

      if( !this.name ){ return false}

      this.$axios({
        url: '/ajax/?addTestimonials=Y',
        method: 'post',
        params: {
          article: this.article,
          site_id: this.$store.state.siteid,
          template_site: this.$store.state.langs.TEMPLATE_SITE,
          raiting: this.raiting,
          name: this.name,
          city: this.city,
          email: this.email,
          phone: this.phone,
          text: this.text,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          //console.log( "response", response );
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'review_sent');
          }
          this.sended = true;
          //this.$emit('sended');
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })

      this.$emit('sended');

    },
    showError(propertyName) {
      const el = document.getElementsByName(propertyName);
      if (el[0].hasChildNodes) {
        const error = el[0].querySelector(".error-message")
        if (error === null) {
          let div = document.createElement("div")
          div.classList.add("error-message")
          div.append("Заполните это поле")
          el[0].append(div)
          let inp = el[0].querySelector('input');
          inp.classList.add("error")
        }
      }
    },
    hideError(propertyName) {
      const el = document.getElementsByName(propertyName)
      if (el.length > 0) {
        let inp = el[0].querySelector('input');
        inp.classList.remove("error");
        let messageError = el[0].querySelector('.error-message');
        if(messageError) {
          messageError.remove();
        }
      }
    },
  },
  computed: {
    currentTabIndex() {
      return this.tabs.findIndex(t => t === this.current)
    }
  },
  watch: {
    //currentTabIndex() {
    //  this.setCurrentTab()
    //}
  },
  components: {
    Slide, Carousel, PhoneMaskInput,
    'ui-switcher': () => import('@/components/ui/ui-switcher'),
    'ui-testimonial-card': () => import('@/components/ui/ui-testimonial-card'),
    'ui-button': () => import('@/components/ui/ui-button'),
    'layout-testimonial-card': () => import('@/components/layout/testimonial/layout-testimonial-card'),
    'layout-popup': () => import('@/components/layout/layout-popup'),
    'ui-raiting': () => import('@/components/ui/ui-raiting')
  }
}
</script>

<style lang="scss" scoped>
.layout-product-testimonials {
  text-align: center;
}
.ui-switcher {
  display: inline-flex !important;
  margin-top: 1em;
}
.suffix {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 3em;
}
.content-wrapper {
  margin: 2em auto;
  text-align: left;
  max-width: 800px;
  width: 100%;
  & > * {
    margin-bottom: 30px;
    padding-bottom: 30px;
    &:not(:last-child) {
      border-bottom: solid 1px var(--light);
    }
    &.hidden {
      display: none;
    }
  }
}
.row-fields {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  position: relative;
}
[name="CLIENT_EMAIL"] {
  position: relative;
}
.rainting {
  padding: 1em 0;
}
@media screen and (max-width: 767px) {
  .content-wrapper {
    & > div {
      grid-template-columns: 1fr;
    }
  }
}
</style>